import type { ReactNode } from "react";

/** Horizontally scrollable table region, keyboard-focusable so it can scroll on small screens. */
export function TableScroll({ label, children }: { label: string; children: ReactNode }) {
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- focusable so keyboard users can scroll it (axe scrollable-region-focusable)
    <div className="relative overflow-x-auto focus-visible:outline-2 focus-visible:outline-primary" role="region" aria-label={label} tabIndex={0}>
      {children}
    </div>
  );
}
